import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const SiteContext = createContext(null);
export const useSite = () => useContext(SiteContext);

export function SiteProvider({ children }) {
  const [content, setContent] = useState(null);
  const [products, setProducts] = useState([]);
  const [downloads, setDownloads] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const [c, p, d] = await Promise.all([
        api.get("/content"),
        api.get("/products"),
        api.get("/downloads"),
      ]);
      setContent(c.data);
      setProducts(p.data);
      setDownloads(d.data);
    } catch (e) {
      console.error("site load error", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <SiteContext.Provider
      value={{ content, products, downloads, loading, reload: load, setContent }}
    >
      {children}
    </SiteContext.Provider>
  );
}
